export const font = {
  sizes: {
    res: 'clamp(13.5px, 1.2vw, 16px)'
  },
  res: {
    lg: 'clamp(13px, 1.2vw, 16px)',
    sm: `clamp(9px,.7vw,13px)`,
    base: `clamp(10px,.8vw,14px)`
  }
};
